// One-time Chart.js registration for the Payment Bot Dashboard charts. Importing
// this module for its side effect registers every controller/element/scale the
// month-trend (Line) and Error Breakdown (Bar) charts need. Registering twice is a no-op,
// so it is safe for multiple chart components to import this.
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title as ChartTitle,
  Tooltip,
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  LineController,
  LineElement,
  PointElement,
  ChartTitle,
  Tooltip,
  Legend
)
